import { useCallback, useState } from 'react';
import userIcon from '../../assets/svg/navDropdownIcon/user.svg';
import profileTick from '../../assets/svg/navDropdownIcon/profile-tick.svg';
import configureIcon from '../../assets/svg/navDropdownIcon/configure.svg';
import messageIcon from '../../assets/svg/navDropdownIcon/message.svg';
import logoutIcon from '../../assets/svg/navDropdownIcon/logout.svg';
import { setValues, getValues, removeValues } from 'services/storage';
import { useNavigate } from 'react-router-dom';
import Alert from 'components/atoms/Alert';
import { handleException, logoutFunc } from 'utils';
import viewFeeIcon from '../../assets/svg/document-text.svg';
import editFeeIcon from '../../assets/svg/edit_doc.svg';
import trackBusinessIcon from '../../assets/svg/home-trend-up-black.svg';

const NavDropdownData = (logoutHandler, bearerToken) => {
    const [modalState, setModalState] = useState(false);
    const [modalId, setModalId] = useState('');

    const navigate = useNavigate();

    const handleLogout = () => {
        logoutHandler();
        localStorage.clear();
        sessionStorage.clear();
        // window.location.href = '/auth/login';
        navigate('/auth/login');
    }

    const handleViewFees = () => {
        if (modalState) {
            setModalState(false);
            setModalId('');
        } else {
            setModalState(true);
            setModalId('view_fees');
        }
    }

    const handleEditFees = () => {
        if (modalState) {
            setModalState(false);
            setModalId('');
        } else {
            setModalState(true);
            setModalId('edit_fees');
        }
    }

    const dropdownData = [
        // { icon: viewFeeIcon, title: "View Fees", style: "", link: null, action: () => null },
        // { icon: editFeeIcon, title: "Edit Fees", style: "", link: null, action: () => null },
        // { icon: trackBusinessIcon, title: "Track Business", style: "", link: `/dashboard/track_business`, action: () => null },
        // { icon: logoutIcon, title: "Logout", style: "border-t ", link: null, action: handleLogout }
        { icon: logoutIcon, title: "Logout", style: "", link: null, action: handleLogout }
    ]

    return { dropdownData, modalId, modalState, setModalState }
}

export default NavDropdownData;